import React, { useContext, useEffect, useRef, useState } from "react";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import axios from "axios";
import { Auth } from "../../../contextapi/Authcontext/Authcontext";


const BASE_URL = process.env.REACT_APP_BASE_URL 

class UploadAdapter {
  constructor(loader, accessToken) {
    this.loader = loader;
    this.accessToken = accessToken;
    this.controller = new AbortController();
  }

  upload() {
    return this.loader.file.then((file) => {
      console.log(this.accessToken)
      const formData = new FormData();
      formData.append("image", file);
      return axios
        .post(`${BASE_URL}/api/admin/s3`, formData, {
          signal: this.controller.signal,
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${this.accessToken}`,
          },
          onUploadProgress: (e) => {
            if (e.total) {
              this.loader.uploadedPercent = (e.loaded / e.total) * 100;
            }
          },
        })
        .then((res) => {
          // Support both response shapes: { uploaded: ["url"] } or { url: "..." }
          const url =
            (Array.isArray(res.data?.uploaded) && res.data.uploaded[0]) ||
            res.data?.url ||
            res.data?.data?.url ||
            "";
          if (!url) throw new Error("Upload succeeded but no URL returned from server.");
          return { default: url };
        });
    });
  }

  abort() {
    this.controller.abort();
  }
}


function registerUploadAdapter(editor, accessToken) {
  editor.plugins.get("FileRepository").createUploadAdapter = (loader) =>
    new UploadAdapter(loader, accessToken);
}


const TEMPLATES = [
  {
    label: "Template 1 — Standard Article",
    html: `<h1>Your Blog Title Here</h1>
<p><em>Write a short, engaging introduction that hooks the reader in 2–3 sentences.</em></p>

<h2>Section One Heading</h2>
<figure class="image image-style-side"><img src="https://placehold.co/400x300?text=Your+Image" alt="section image"></figure>
<p>Replace this paragraph with your first section content. Explain the topic clearly and concisely.</p>
<p>Add a second paragraph here if needed to expand on the idea.</p>

<h2>Section Two Heading</h2>
<ul>
  <li><strong>Point One:</strong> Brief explanation of this point.</li>
  <li><strong>Point Two:</strong> Brief explanation of this point.</li>
  <li><strong>Point Three:</strong> Brief explanation of this point.</li>
</ul>

<h2>Quick Comparison</h2>
<figure class="table">
  <table>
    <thead><tr><th>Feature</th><th>Option A</th><th>Option B</th></tr></thead>
    <tbody>
      <tr><td>Quality</td><td>High</td><td>Medium</td></tr>
      <tr><td>Price</td><td>Affordable</td><td>Expensive</td></tr>
      <tr><td>Health Benefit</td><td>Yes</td><td>No</td></tr>
    </tbody>
  </table>
</figure>

<blockquote><p>Add an impactful quote or key stat here to break up the content.</p></blockquote>

<h2>Conclusion</h2>
<p>Summarize your key points here. Tell the reader what action to take or what to remember. Keep it short and impactful.</p>`,
  },
  {
    label: "Template 2 — Listicle / Top-5 Post",
    html: `<h1>Top 5 [Your Topic] You Should Know</h1>
<p>Write 2–3 sentences introducing why this topic matters to your readers. Keep it friendly and approachable.</p>

<h2>1. First Point Title</h2>
<p>Explain this point in 2–3 sentences. Use simple, clear language. Add real-life examples if possible.</p>

<h2>2. Second Point Title</h2>
<p>Explain this point in 2–3 sentences.</p>

<h2>3. Third Point Title</h2>
<p>Explain this point in 2–3 sentences.</p>

<h2>4. Fourth Point Title</h2>
<p>Explain this point in 2–3 sentences.</p>

<h2>5. Fifth Point Title</h2>
<p>Explain this point in 2–3 sentences.</p>

<blockquote><p><strong>Key Takeaway:</strong> Write your final thought or call-to-action here. Tell readers what to do next.</p></blockquote>`,
  },
  {
    label: "Template 3 — Product Review Post",
    html: `<h1>Your Product / Topic Name — Full Review</h1>
<p><strong>Rating: ★★★★☆ (4/5)</strong> &nbsp;|&nbsp; <em>Excellent Choice</em></p>

<blockquote><p><strong>Quick Summary:</strong> Write a 3–4 sentence summary of what this post is about. This helps readers quickly decide if they want to read more.</p></blockquote>

<h2>What Is [Product / Topic]?</h2>
<p>Give a detailed introduction here. Explain what it is, where it comes from, and why it matters.</p>

<h2>Pros &amp; Cons</h2>
<figure class="table">
  <table>
    <thead><tr><th>✅ Pros</th><th>❌ Cons</th></tr></thead>
    <tbody>
      <tr><td>Benefit number one</td><td>Drawback number one</td></tr>
      <tr><td>Benefit number two</td><td>Drawback number two</td></tr>
      <tr><td>Benefit number three</td><td>Drawback number three</td></tr>
    </tbody>
  </table>
</figure>

<h2>Step-by-Step Guide</h2>
<ol>
  <li><strong>Step One:</strong> Describe the first step clearly.</li>
  <li><strong>Step Two:</strong> Describe the second step clearly.</li>
  <li><strong>Step Three:</strong> Describe the third step clearly.</li>
  <li><strong>Step Four:</strong> Describe the fourth step clearly.</li>
</ol>

<h2>Frequently Asked Questions</h2>
<p><strong>Q: Write your first question here?</strong><br>Write the answer here. Keep it short and helpful.</p>
<p><strong>Q: Write your second question here?</strong><br>Write the answer here.</p>
<p><strong>Q: Write your third question here?</strong><br>Write the answer here.</p>

<h2>Final Verdict</h2>
<p>Write your final recommendation here. Should readers buy/try/use this? Why? Be direct and honest.</p>`,
  },
];


function Editortinyme({ value }) {
  const userDetail = JSON.parse(localStorage.getItem("userToken"));
  const { editorState, setEditorState } = useContext(Auth);
  const editorInstanceRef = useRef(null);
  const isMounted = useRef(true);
  const lastValueRef = useRef(null); 

  const [htmlMode, setHtmlMode] = useState(false);
  const [rawHtml, setRawHtml] = useState("");
  const [activeTemplate, setActiveTemplate] = useState("");
  const [wordCount, setWordCount] = useState(0);
  const [ckReady, setCkReady] = useState(!!window.ClassicEditor);
  const accessToken = userDetail?.accesstoken || "";

  useEffect(() => {
    if (window.ClassicEditor) { setCkReady(true); return; }
    const timer = setInterval(() => {
      if (window.ClassicEditor) { setCkReady(true); clearInterval(timer); }
    }, 100);
    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    isMounted.current = true;
    return () => {
      isMounted.current = false;
      editorInstanceRef.current = null;
    };
  }, []);

  
  useEffect(() => {
    const incoming = value || "";

    if (incoming === lastValueRef.current) return;
    lastValueRef.current = incoming;

    setEditorState({ editorHtml: incoming });
    setRawHtml(incoming);

    if (editorInstanceRef.current && isMounted.current) {
      try {
        editorInstanceRef.current.setData(incoming);
      } catch (_) {}
    }
  }, [value]);

  const toggleHtmlMode = () => {
    if (!htmlMode) {
      const html = editorInstanceRef.current
        ? editorInstanceRef.current.getData()
        : editorState.editorHtml;
      setRawHtml(html);
    } else {
      setEditorState({ editorHtml: rawHtml });
      if (editorInstanceRef.current) {
        editorInstanceRef.current.setData(rawHtml);
      }
    }
    setHtmlMode((v) => !v);
  };

  const handleTemplateChange = (e) => {
    const idx = Number(e.target.value);
    if (idx === -1) return;
    const tpl = TEMPLATES[idx];
    if (!tpl) return;
    setActiveTemplate(e.target.value);
    setEditorState({ editorHtml: tpl.html });
    setRawHtml(tpl.html);
    if (editorInstanceRef.current) {
      editorInstanceRef.current.setData(tpl.html);
    }
    if (htmlMode) setHtmlMode(false);
  };

  return (
    <div className="bk-editor-wrapper">
      {/* ── Top bar ─────────────────────────────────────────────── */}
      <div className="bk-editor-topbar">
        {/* Template picker */}
        <div className="bk-editor-topbar-left">
          <label className="bk-label">
            <span>📄 Insert Template</span>
            <select
              value={activeTemplate}
              onChange={handleTemplateChange}
              className="bk-select"
            >
              <option value="-1">— choose a template —</option>
              {TEMPLATES.map((t, i) => (
                <option key={i} value={i}>
                  {t.label}
                </option>
              ))}
            </select>
          </label>
        </div>

        {/* Right controls */}
        <div className="bk-editor-topbar-right">
          <span className="bk-wordcount">{wordCount} words</span>
          <button
            type="button"
            className={`bk-btn-html ${htmlMode ? "active" : ""}`}
            onClick={toggleHtmlMode}
            title={htmlMode ? "Switch to Visual Editor" : "Edit Raw HTML"}
          >
            {htmlMode ? "⬅ Visual Editor" : "</> HTML Source"}
          </button>
        </div>
      </div>

      {/* ── Visual editor (CKEditor) ─────────────────────────────── */}
      <div style={{ display: htmlMode ? "none" : "block" }}>
        {!ckReady ? (
          <div style={{ padding: "40px", textAlign: "center", color: "#888" }}>
            Loading editor…
          </div>
        ) : (
        <CKEditor
          editor={window.ClassicEditor}
          initialData={value || ""}
          onReady={(editor) => {
            editorInstanceRef.current = editor;
            registerUploadAdapter(editor, accessToken);
            // Load the value prop directly — don't rely on editorState
            // which may hold stale content from a previously opened blog
            const initial = value || "";
            lastValueRef.current = initial;
            if (initial) {
              try { editor.setData(initial); } catch (_) {}
            }
            setEditorState({ editorHtml: initial });
            setRawHtml(initial);
          }}
          onChange={(_event, editor) => {
            if (!editorInstanceRef.current) return;
            const html = editor.getData();
            setEditorState({ editorHtml: html });
            setRawHtml(html);
            const text = html.replace(/<[^>]+>/g, " ").replace(/\s+/g, " ").trim();
            setWordCount(text ? text.split(" ").length : 0);
          }}
          onError={(error, { willEditorRestart }) => {
            console.error("CKEditor error:", error);
            if (willEditorRestart) {
              editorInstanceRef.current = null;
            }
          }}
          config={{
            toolbar: {
              items: [
                "heading",
                "|",
                "bold",
                "italic",
                "underline",
                "strikethrough",
                "|",
                "alignment",
                "|",
                "bulletedList",
                "numberedList",
                "outdent",
                "indent",
                "|",
                "blockQuote",
                "insertTable",
                "mediaEmbed",
                "link",
                "imageUpload",
                "|",
                "undo",
                "redo",
              ],
              shouldNotGroupWhenFull: true,
            },
            heading: {
              options: [
                { model: "paragraph", title: "Paragraph", class: "ck-heading_paragraph" },
                { model: "heading1", view: "h1", title: "Heading 1", class: "ck-heading_heading1" },
                { model: "heading2", view: "h2", title: "Heading 2", class: "ck-heading_heading2" },
                { model: "heading3", view: "h3", title: "Heading 3", class: "ck-heading_heading3" },
                { model: "heading4", view: "h4", title: "Heading 4", class: "ck-heading_heading4" },
              ],
            },
            image: {
              toolbar: [
                "imageStyle:inline",
                "imageStyle:block",
                "imageStyle:side",
                "|",
                "toggleImageCaption",
                "imageTextAlternative",
              ],
            },
            table: {
              contentToolbar: [
                "tableColumn",
                "tableRow",
                "mergeTableCells",
                "tableProperties",
                "tableCellProperties",
              ],
            },
            mediaEmbed: {
              previewsInData: true,
            },
          }}
        />
        )}
      </div>

      {/* ── Raw HTML editor ──────────────────────────────────────── */}
      {htmlMode && (
        <div className="bk-html-editor">
          <div className="bk-html-editor-header">
            <span>✏️ Edit HTML Source — changes apply when you click "Visual Editor"</span>
          </div>
          <textarea
            className="bk-html-textarea"
            value={rawHtml}
            onChange={(e) => setRawHtml(e.target.value)}
            spellCheck={false}
            autoComplete="off"
            autoCorrect="off"
            autoCapitalize="off"
          />
        </div>
      )}
    </div>
  );
}

export default Editortinyme;
